// extracted by mini-css-extract-plugin
export default {"textInputWrapper":"_c2a8dd3a","uppercased":"_8360a890","isFocused":"_5b636af5","animatedPlaceholderPadding":"_5138e60f","usePaddingLeft":"_b952cceb"};